export default {
    name: {
        invalid: 'Name only allow letters',
        required: 'Name is required'
    },
    lastName: {
        invalid: 'Last name only allow letters',
        required: 'Last Name is required'
    },
    country: {
        required: 'Country is required'
    },
    state: {
        required: 'Department is required'
    },
    city: {
        required: 'City is required'
    },
    language: {
        required: 'Language is required'
    },
    email: {
        email: 'Invalid email address',
        required: 'Email is required'
    },
    password: {
        min: 'Password must be at least {min} characters',
        required: 'Password is required'
    },
    passwordConfirm: {
        match: 'Passwords must match',
        required: 'Password confirmation is required'
    },
    brand: {
        required: 'Comercial brand is required'
    },
    economicActivity: {
        required: 'Economic activity is required'
    },
    companyCategory: {
        required: 'Company category is required'
    },
    companyType: {
        required: 'Company type is required'
    },
    code: {
        required: 'Code is required'
    },
    description: {
        required: 'Description is required',
        maxLength: 'Description cannot exceed 500 characters'
    },
    category: {
        required: 'Category is required'
    },
    subcategory: {
        required: 'Subcategory is required'
    },
    severity: {
        required: 'Severity is required'
    },
    assetType: {
        required: 'Asset type is required'
    },
    assetCategory: {
        required: 'Asset category is required'
    },
    controlAction: {
    required: 'Control action is required'
    },
    selectedImpact: {
        required: 'At least one selected impact is required'
    },
    selectedControlDomain: {
        required: 'Control domain is required'
    },
    selectedControl: {
        required: 'Control selection is required'
    },
    responsible: {
        required: 'Responsible person is required'
    },
    creationDate: {
        required: 'Creation date is required'
    },
    nextFollowUp: {
        required: 'Next follow-up date is required'
    },
    treatmentActionDescription: {
        required: 'Treatment action description is required',
        maxLength: 'Treatment action description cannot exceed 500 characters',
        minLength: 'Treatment action description must be at least 20 characters'
    },
    subdomain: {
        required: 'Subdomain is required',
    },
    assetSecurityRequirements: {
        required: 'The asset security requirement description is required'
    },
    assetImpactAreas: {
        required: 'The impact factors are required'
    },
    organizationalProcess: {
        required: 'The organizational areas and processes are required'
    },
    validityStartDate: {
        required: 'The validity start date is required'
    },
    validityEndDate: {
        required: 'The validity end date is required',
        afterStart: 'The end date must be after the start date'
    },
    codeRequired: 'The code is required',
    nameEsRequired: 'The Spanish name is required',
    nameEnRequired: 'The English name is required',
    priceType: 'The price must be a number',
    priceRequired: 'The price is required',
    priceMin: 'The price cannot be negative',
    currencyRequired: 'The currency is required',
    billingPeriodRequired: 'The billing period is required'
};